import { Component, EventEmitter, Input, Output, ViewChild, ElementRef, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-search-bar-inline',
  templateUrl: './search-bar-inline.component.html',
  styleUrls: ['./search-bar-inline.component.scss'],
  standalone: false
})
export class SearchBarInlineComponent implements AfterViewInit {
  @Input() placeholder: string = '';
  @Input() search: string = '';
  @Output() searchChange = new EventEmitter<string>();
  @Output() searchClear = new EventEmitter<void>();

  @ViewChild('searchInput') inputRef!: ElementRef<HTMLInputElement>;
  private shouldFocus = false;

  ngAfterViewInit(): void {
    if (this.shouldFocus) {
      this.focusInput();
    }
  }

  public focusInput() {
    this.shouldFocus = true;
    setTimeout(() => {
      this.inputRef?.nativeElement?.focus();
    }, 0);
  }

  clearSearch() {
    this.search = '';
    this.searchChange.emit('');
    this.searchClear.emit();
  }
}
